import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import routing from "../../../routing";
import Icons from "../../../icons";
import Icon from "../../../icon";

import { StaffLines } from "../StaffLines";

import messages from "./messages";
import { StyledNavLeft, MenuItem, Logo, StyledStaffLinesLeft } from "./styles";
import { IProps } from "../NavRight/interfaces";

const NavLeft = ({
    loggedIn,
    profiled,
    isPathBrowse,
    isPathDashboard,
    isPathDashboardActive,
    isPathHomeworks,
    isPathHomeworksActive,
    isPathHomework,
    isStudentDashboard,
    user,
}: IProps) => {
    const { formatMessage, locale } = useIntl();
    const { isStudent = false } = user;
    return (
        <StyledNavLeft>
            <Logo>
                <Link to="/">
                    <StyledStaffLinesLeft>
                        <StaffLines />
                    </StyledStaffLinesLeft>
                    <Icons.Logo slogen={formatMessage(messages.slogen)} locale={locale} />
                </Link>
            </Logo>
            {!isStudent && (
                <MenuItem $isActive={isPathBrowse === 1 || undefined} to={"/" + routing.browse}>
                    <Icon i="browse" />
                    <span><FormattedMessage {...messages.browse} /></span>
                </MenuItem>
            )}
            {loggedIn && profiled && (
                <MenuItem
                    $isActive={isPathDashboard === 1 || undefined}
                    to={"/" + routing.dashboard}
                    onClick={e => {
                        if (isPathDashboardActive) {
                            e.preventDefault();
                        }
                    }}
                >
                    <Icon i="dashboard" />
                    <span><FormattedMessage {...messages.editor} /></span>
                </MenuItem>
            )}
            {loggedIn && profiled && (
                <MenuItem
                    $isActive={isPathHomeworks === 1 || undefined}
                    to={"/" + routing.classes}
                    onClick={e => {
                        if (isPathHomeworksActive) {
                            e.preventDefault();
                        }
                    }}
                >
                    <Icon i="whiteboard" style={{ marginTop: 3 }} />
                    <span><FormattedMessage {...messages.classes} /></span>
                </MenuItem>
            )}
            {!loggedIn && (
                <MenuItem $isActive={isPathHomework === 1 || undefined} to={"/" + routing.homework}>
                    <Icon i="homework" />
                    <span><FormattedMessage {...messages.homework} /></span>
                </MenuItem>
            )}
            {isStudent && (
                <MenuItem to={"/" + routing.dashboardStudent} $isActive={isStudentDashboard === 1 || undefined}>
                    <Icon i="dashboard" />
                    <span><FormattedMessage {...messages.dashboardStudent} /></span>
                </MenuItem>
            )}
            {(!loggedIn || isStudent) && (
                <MenuItem to={"/" + routing.join}>
                    <Icon i="whiteboard" style={{ marginTop: 3 }}/>
                    <span><FormattedMessage {...messages.join} /></span>
                </MenuItem>
            )}
        </StyledNavLeft>
    );
};

export default NavLeft;
